<template>
    <div style="overflow-x: hidden; overflow-y: none; height: fit-content; padding-bottom: 130px">
        <div v-if="$store.state.badgesOther !== ''" class="award-header">Achievements</div>
        <div v-if="$store.state.badgesOther !== ''" class="badge-container">
            <div
                class="badge-div"
                v-for="badge in Object.values(this.$store.state.badgesOther)"
                :key="badge.badge_type"
            >
                <Badges :badge="badge" />
            </div>
        </div>
        <div class="middle5-right-grid">
            <div class="mid5-padd cursor-default">
                <p class="middle5-text">Current club:</p>
                <div>
                    <p class="gold" style="margin-top: 1.25rem">
                        {{ user.current_clubs }}
                    </p>
                </div>
            </div>
            <div class="mid5-padd cursor-default">
                <p class="middle5-text">Current league:</p>
                <p class="gold" style="margin-top: 1.25rem">
                    {{ user.current_leagues }}
                </p>
            </div>
        </div>
        <div class="middle5-right-grid">
            <div class="mid5-padd" :class="{ colored: user.current_playing_bool }">
                <div style="height: 4.0625rem; display: flex; position: relative">
                    <p class="middle5-text cursor-default">Currently active:</p>
                    <img
                        v-if="user.current_playing_bool"
                        class="plava-kugla"
                        src="../../assets/plavakugla.png"
                        alt=""
                    />
                </div>
                <b-form-checkbox switch disabled :checked="user.current_playing_bool" style="padding-left: 3.4375rem" />
                <div class="cursor-default">
                    <p v-if="user.current_playing_bool" class="gold currently-active-div">
                        {{ user.current_playing }}
                    </p>
                </div>
            </div>
            <div class="mid5-padd">
                <p class="middle5-text cursor-default">Player form:</p>
                <div id="form-middle5">
                    <div v-if="user.shape == null">
                        <img class="unknown" src="../../assets/player-form-unkown-icon.svg" alt="" />
                        <p style="margin: 0; padding: 0.5rem 0 0 0">Unknown</p>
                    </div>

                    <div v-if="user.shape == 'good'">
                        <svg
                            style="transform: rotate(45deg)"
                            xmlns="http://www.w3.org/2000/svg"
                            height="26"
                            fill="#07da63"
                            viewBox="0 -960 960 960"
                            width="26"
                        >
                            <path
                                d="m357-384 123-123 123 123 57-56-180-180-180 180 57 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                            />
                        </svg>
                        <p class="color-green" style="margin: 0; padding: 0.5rem 0 0 0; color: #07da63">Good</p>
                    </div>

                    <div v-if="user.shape == 'excellent'">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#11c6d1"
                            height="26"
                            viewBox="0 -960 960 960"
                            width="26"
                        >
                            <path
                                d="m357-384 123-123 123 123 57-56-180-180-180 180 57 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                            />
                        </svg>
                        <p style="margin: 0; padding: 0.5rem 0 0 0; color: #11c6d1">Excellent</p>
                    </div>

                    <div v-else-if="user.shape == 'weak'">
                        <!-- <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1311_17217)">
                                <path
                                    d="M16.1458 11.0006L12 15.1464L7.85418 11.0006L8.91938 9.94293L11.8232 12.8468L12 13.0236L12.1768 12.8468L15.0806 9.94293L16.1458 11.0006ZM2.25 12C2.25 6.61807 6.61807 2.25 12 2.25C17.3819 2.25 21.75 6.61807 21.75 12C21.75 17.3819 17.3819 21.75 12 21.75C6.61807 21.75 2.25 17.3819 2.25 12ZM3.75 12C3.75 16.5581 7.44193 20.25 12 20.25C16.5581 20.25 20.25 16.5581 20.25 12C20.25 7.44193 16.5581 3.75 12 3.75C7.44193 3.75 3.75 7.44193 3.75 12Z"
                                    fill="#F2358D"
                                    stroke="#202122"
                                    stroke-width="0.5"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_1311_17217">
                                    <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                        </svg> -->

                        <svg
                            fill="#f2358d"
                            xmlns="http://www.w3.org/2000/svg"
                            height="26"
                            viewBox="0 -960 960 960"
                            width="26"
                        >
                            <path
                                d="m480-340 180-180-57-56-123 123-123-123-57 56 180 180Zm0 260q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                            />
                        </svg>
                        <p style="margin: 0; padding: 0.5rem 0 0 0; color: #f2358d">Weak</p>
                    </div>

                    <div v-else-if="user.shape == 'neutral'">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#c8a07d"
                            height="24"
                            viewBox="0 -960 960 960"
                            width="24"
                        >
                            <path d="M240-440v-80h480v80H240Z" />
                        </svg>

                        <p style="margin: 0; padding: 0.5rem 0 0 0">Neutral</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle5-right-grid cursor-default" style="height: 10.625rem">
            <div class="mid5-padd padd2">
                <p class="middle5-text open-engagements">Open to new engagements</p>

                <div>
                    <div class="engage-grid stikl" :class="{ stikl1: user.open2new_eng_club === false }">
                        <p class="gold2">Club</p>
                        <img class="engage-stikl" src="../../assets/stikla.png" alt="" />
                    </div>
                    <div class="engage-grid stikl" :class="{ stikl1: user.open2new_eng_tournament === false }">
                        <p class="gold2">Tournaments</p>
                        <img class="engage-stikl" src="../../assets/stikla.png" alt="" />
                    </div>
                    <!--   <div class="engage-grid stikl" :class="{ stikl1: user.open2new_eng_event === false }">
                        <p class="gold2">Events</p>
                        <img class="engage-stikl" src="../../assets/stikla.png" alt="" />
                    </div>  -->
                </div>
            </div>
            <div class="mid5-padd flex-center">
                <div>
                    <div v-if="interested_no" style="margin-bottom: 0.625rem" class="borderbutton flex-center">
                        <p @click="interested_player">Interested in this Player</p>
                    </div>
                    <div v-if="clicked_interested2">
                        <div v-if="interested_yes()" class="borderbutton flex-center">
                            <div style="font-size: 14px">
                                <p @click="interested_player_del">Remove from shortlist</p>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="clicked_interested"
                        style="margin-bottom: 0.625rem"
                        class="borderbutton flex-center"
                        @click="interested_player_del"
                    >
                        <p style="font-size: 14px">Remove from shortlist</p>
                    </div>
                </div>
            </div>
        </div>
        <div id="middle5-right-end">
            <p class="middle5-text">Desired club compensation</p>
            <div class="parent_range">
                <v-app class="vuetify-switch">
                    <v-container class="switch-container">
                        <v-card flat color="transparent">
                            <v-subheader />
                            <v-card-text>
                                <v-row>
                                    <v-col class="px-4">
                                        <v-range-slider
                                            v-model="rangeclub"
                                            :max="max"
                                            :min="min"
                                            hide-details
                                            class="align-center"
                                            disabled
                                        >
                                            <template v-slot:prepend>
                                                <v-text-field
                                                    :value="user.comp_per_game_from"
                                                    class="mt-0 pt-0"
                                                    hide-details
                                                    single-line
                                                    type="number"
                                                    style="width: 0px"
                                                />
                                            </template>
                                            <template v-slot:append>
                                                <v-text-field
                                                    :value="user.comp_per_game_to"
                                                    class="mt-0 pt-0"
                                                    hide-details
                                                    single-line
                                                    type="number"
                                                    style="width: 0px"
                                                />
                                            </template>
                                        </v-range-slider>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-app>
            </div>
            <div class="slider">
                <p>{{ user.comp_per_game_from }} €</p>
                -
                <p>{{ user.comp_per_game_to }} €</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Player",
    props: {
        user: {},
    },
    components: {
        Badges: () => import("../Profile/Badges.vue"),
    },
    data() {
        return {
            clicked_interested: false,
            clicked_interested2: true,
            listpla: { target_uuid: "" },
            interested_no: true,
            rangeclub: [350, 1850],
            min: 0,
            max: 3000,
            //  my_interested_list: {},
        };
    },
    created() {
        this.idt = this.$route.params.id;

        // fetch(process.env.VUE_APP_URL + "/interested_in_player", {
        //     method: "GET",
        //     headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
        // })
        //     .then(response => response.json())
        //     .then(data => (this.my_interested_list = data));
        // .then(data => console.log('my_list',data))
    },
    mounted() {
        //  console.log("khakud", this.$store.state.badgesOther!=='');
        // console.log('this.interestedInfo1',this.interestedInfo)
    },
    methods: {
        interested_yes() {
            if (this.$store.state.interestedPlayer == true) {
                this.interested_no = false;
                return true;
            }
        },
        /* INTERESTED PLAYER */

        interested_player() {
            this.interested_no = false;
            this.clicked_interested = true;
            this.clicked_interested2 = false;
            this.$store.commit("SET_INT_PLAYER", true);
            fetch(process.env.VUE_APP_URL + `/interested_in_player/${this.idt} `, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
        },
        interested_player_del: function () {
            this.interested_no = true;
            this.clicked_interested = false;
            this.clicked_interested2 = false;
            this.$store.commit("SET_INT_PLAYER", false);
            fetch(process.env.VUE_APP_URL + `/interested_in_player/${this.idt} `, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
        },
    },
};
</script>

<style scoped>
.middle5-text {
    padding: 0.9375rem 0 5px 1.25rem;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.25rem;
    letter-spacing: 0.01rem;
}
.mid5-padd {
    padding: 0.625rem 0.3rem;
    position: relative;
}
.open-engagements {
    margin-bottom: 0.625rem;
    margin-top: 12px;
}
.middle5-right-grid > div {
    background-color: #202122;
}

.middle5-right-grid {
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 2%;
    height: 10rem;
    margin-bottom: 2%;
    text-align: left;
}
.mid5-padd >>> .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #202122 !important;
    color: rgba(200, 160, 125, 1) !important;
    border-color: rgba(200, 160, 125, 1) !important;
}
.mid5-padd >>> .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: rgba(200, 160, 125, 1) !important;
}
.mid5-padd >>> .custom-control-label::before {
    background-color: black !important;
}
.mid5-padd >>> .custom-control-label {
    cursor: pointer;
}
.award-header {
    border-top: 1px solid rgba(84, 84, 84, 0.2);
    border-left: 1px solid rgba(84, 84, 84, 0.2);
    border-right: 1px solid rgba(84, 84, 84, 0.2);
    background-color: #202122;
    text-align: left;
    padding-left: 1.55rem;
    padding-top: 1.55rem;
}
#form-middle5 {
    color: #c8a07d;
    text-align: center;
    padding-top: 0.875rem;
    font-size: 14px;
}
.borderbutton {
    width: 192px;
    height: 44px;
    border: 1px solid #2e2e2e;
    box-sizing: border-box;
    border-radius: 6px;
    text-align: center;
}
.borderbutton:hover {
    opacity: 0.7;
    cursor: pointer;
}
.borderbutton > p {
    font-size: 14px;
    padding: 0 5px 0 5px;
}
.plava-kugla {
    height: 6rem;
    position: absolute;
    top: -1.5rem;
    right: -1.5rem;
    opacity: 0.9;
}

.gold {
    color: #c8a07d;
    font-size: 0.875rem;
    margin-top: 10%;
    padding-left: 1.25rem;
}
.gold2 {
    color: #c8a07d;
    font-size: 14px;
    padding-left: 1.25rem;
}

.engage-grid {
    display: grid;
    grid-template-columns: 80% 20%;

    padding-top: 5px;
}
.engage-stikl {
    height: 14px;
    cursor: pointer;
}
.stikl1 {
    opacity: 0.3;
}
.parent_range >>> .v-slider__track-fill {
    background-image: linear-gradient(to left, rgba(17, 198, 209, 1), rgba(200, 160, 125, 1)) !important;
}
.parent_range >>> .v-slider__track-background:first-child {
    background-color: rgba(17, 198, 209, 1) !important;
}
.parent_range >>> .v-slider__track-background:last-child {
    background-color: rgba(17, 198, 209, 1) !important;
}

.parent_range >>> .v-slider > .v-slider__thumb-container:last-child > .v-slider__thumb {
    background-color: rgba(17, 198, 209, 1) !important;
}
.parent_range >>> .v-slider > .v-slider__thumb-container > .v-slider__thumb {
    background-color: rgba(17, 198, 209, 1) !important;
}
.parent_range >>> .v-slider__track-background {
    background-color: rgba(17, 198, 209, 1) !important;
}
.parent_range >>> .v-slider__thumb {
    background-color: rgba(17, 198, 209, 1) !important;
}
.mid5-padd >>> .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #202122 !important;
    color: rgba(200, 160, 125, 1) !important;
    border-color: rgba(200, 160, 125, 1) !important;
}
.mid5-padd >>> .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
    background-color: rgba(200, 160, 125, 1) !important;
}
.mid5-padd >>> .custom-control-label::before {
    background-color: black !important;
}

#middle5-right-end {
    height: auto;
    min-height: 9.25rem;
    background-color: #202122;
    padding: 1rem 0;
}
.slider {
    display: flex;
    width: 100%;
    margin: auto;
    width: 15rem;
}
.slider > p {
    width: 4.175rem;
    display: flex;
    margin: auto;
    text-align: center;
    font-size: 14px;
}

.switch-container {
    padding-left: 1.25rem;
    margin: 0;
}
.vuetify-switch {
    height: 0px;
    position: relative;
    bottom: 4rem;
    left: 0.625rem;
}
.unknown {
    height: 25px;
}
.badge-div {
    min-width: 118px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.badge-div-img {
    width: 100px;
    height: 100px;
}
.badge-container {
    margin-bottom: 2%;
    border-left: 1px solid rgba(84, 84, 84, 0.2);
    border-right: 1px solid rgba(84, 84, 84, 0.2);
    border-bottom: 1px solid rgba(84, 84, 84, 0.2);
    flex-wrap: wrap;
    display: flex;
    justify-content: space-around;
    height: auto;
    min-height: 9.25rem;
    background-color: #202122 !important;
    padding: 0.1rem 0;
    position: relative;
    bottom: 4px;
}

.colored {
    background-color: #3a332d !important;
}
.padd2 {
    padding: 0;
}
.currently-active-div {
    margin-top: 1.875rem;
    text-overflow: ellipsis;
    width: auto;
    max-width: 220px;
    overflow: hidden;
    position: relative;
    bottom: 6px;
}

@media only screen and (max-width: 640px) {
    .award-header {
        font-size: 16px;
        font-weight: 700;
        padding-left: 2.467rem;
    }
    .plava-kugla {
        height: 96px;
        top: -2.5rem;
        right: -2rem;
        opacity: 0.9;
    }
    .padd2 {
        padding: 0 0 0 0.625rem;
    }
    .middle5-right-grid {
        display: flex;
        flex-direction: column;
        height: auto;
        margin-bottom: 0;
    }
    .mid5-padd {
        min-height: 140px;
        margin-bottom: 12px;
        padding-left: 15px;
        padding-top: 15px;
    }
    .middle5-text {
        font-size: 16px;
        font-weight: 700;
    }
    .engage-grid {
        grid-template-columns: 85% 15%;
    }
    .open-engagements {
        margin-bottom: 0.625rem;
        margin-top: 0px;
    }
    .middle5-right-grid {
        display: flex;
        flex-direction: column;
        height: auto;
        margin-bottom: 0;
        display: block;
    }
    #middle5-right-end {
        min-height: 180px;
        margin-bottom: 5rem;
        display: block;
        position: relative;
        top: 175px;
        padding-right: 10px;
    }
    .badge-container {
        min-height: 180px;
        margin-bottom: 5rem;
        margin-bottom: 1rem;

        position: relative;
    }
    .gold {
        font-size: 14px;
    }
}
</style>
